import React, { useState, useEffect, useCallback, useRef } from 'react';
import { jsPDF as JsPdf } from 'jspdf';
import { saveAs } from 'file-saver-es';
import { Workbook } from 'exceljs';
import { useMsal } from "@azure/msal-react";
import './competition_list.scss';

import {
  DataGrid,
  Sorting, Selection, HeaderFilter, Scrolling, SearchPanel,
  Export, Column, Toolbar, Item, LoadPanel

} from 'devextreme-react/data-grid';

import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';

import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridToXLSX } from 'devextreme/excel_exporter';


import { FormPopup, CompetitionNewForm, CompetitionPanel } from '../../components';
import { CompetitionStatus } from '../../components';

import { COMPETITION_STATUS_LIST, COURSES, exportFormats } from '../../shared/constants';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { getApiToken } from '../../utils/authUtils.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate } from 'react-router-dom';
import { withLoadPanel } from '../../utils/withLoadPanel';
import { onExporting } from '../../utils/exporter';

const filterStatusList = ['alle', ...COMPETITION_STATUS_LIST];


const editCellStatusRender = () => (
  <SelectBox className='cell-info' dataSource={COMPETITION_STATUS_LIST} itemRender={CompetitionStatus} fieldRender={fieldRender} />
);


const fieldRender = (text) => (
  <>
    <CompetitionStatus text={text} />
    <TextBox readOnly />
  </>
);


const dropDownOptions = { width: 'auto' };

const statisticsCellRender = (cellData) => {
  const { data: rowData } = cellData;
  let text = '';
  
  if (rowData.status === 'Ergebnisse vorhanden') {
    const total = rowData.totalResults || 0;
    const athletes = rowData.distinctAthletesResults || 0;
    const groups = rowData.distinctTraininggroupsResults || 0;
    if (total === 0 && athletes === 0 && groups === 0) {
      return null;
    }
    text = `${groups} / ${athletes} / ${total}`;
  } else {
    const total = rowData.totalEntries || 0;
    const athletes = rowData.distinctAthletesEntries || 0;
    const groups = rowData.distinctTraininggroupsEntries || 0;
    if (total === 0 && athletes === 0 && groups === 0) {
      return null;
    }
    text = `${groups} / ${athletes} / ${total}`;
  }
  
  return (
    <div className={`status status-competition status-${rowData.status?.toLowerCase().replace(/\s/g, '')}`} style={{ fontSize: '13px' }}>
      {text}
    </div>
  );
};



export const CompetitionList = () => {
    const { instance, accounts } = useMsal();
  const [gridDataSource, setGridDataSource] = useState();
  const [dataSourceUser, setDataSourceUser] = useState();

  const [isdsvLoading, setisdsvLoading] = useState(false);
  const [isPanelOpened, setPanelOpened] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [formDataDefaults, setFormDataDefaults] = useState({});
  const gridRef = useRef(null);
  const navigate = useNavigate();

  let newCompetitionData;
  const CompetitionNewFormWithLoadPanel = withLoadPanel(CompetitionNewForm);
  useEffect(() => {
    getApiToken(instance, accounts).then(token => {
      setGridDataSource({
        store: createStore({
          key: 'competitionId',
          loadUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/CompetitionsView`,
          insertUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/InsertCompetition`,
          updateUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/UpdateCompetition`,
          onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.headers = {
              'Authorization': "Bearer " + token
            };
          },
        })
      });
      const dataSource_user = createStore({
        key: 'userId',
        loadUrl: `${process.env.REACT_APP_serverEndpoint}/User/UsersBasic`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            'Authorization': "Bearer " + token
          };
        },
      });



      dataSource_user.load().done(function (data) {
        setDataSourceUser(data);
      })
    });

  }, []);

  const changePopupVisibility = useCallback((isVisble) => {
    setPopupVisible(isVisble);
  }, []);

  const onAddCompetitionClick = useCallback(() => {
    setPopupVisible(true);
  }, []);

  const onRowClick = useCallback(({ data }) => {
    // setCompetitionId(data.competitionId);
    // setPanelOpened(true);
    const competitionId = data.competitionId;
    navigate(`/competition/edit/${competitionId}`);
  }, []);

  const [status, setStatus] = useState(filterStatusList[0]);

  const filterByStatus = useCallback((e) => {
    const { item: status } = e;
    if (status === 'alle') {
      gridRef.current?.instance().clearFilter();
    } else {
      gridRef.current?.instance().filter(['status', '=', status]);
    }

    setStatus(status);
  }, []);

  const refresh = useCallback(() => {
    gridRef.current?.instance().refresh();
  }, []);

  const onDataChanged = useCallback((data) => {
    newCompetitionData = data;
  }, []);

  const onSaveClick = useCallback(() => {
    notify({
      message: `Neuer Wettkampf "${newCompetitionData.title}" gespeichert`,
      position: { at: 'bottom center', my: 'bottom center' }
    },
      'success'
    );

    setFormDataDefaults({ ...formDataDefaults });
    setPopupVisible(false);
  }, []);
  const onFileChanged = useCallback((e) => {
    setisdsvLoading(true);
    getApiToken(instance, accounts).then(token => {
      const formData = new FormData();
      formData.append('file', e[0]);

      fetch(`${process.env.REACT_APP_serverEndpoint}/Competition/ImportDefinition`, {
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + token
        },
        body: formData

      })
        .then(response => response.json())
        .then(data => {

          if (data.success) {
            notify({
              message: `Wettkampf "${data.result_set.competitionname}" erfolgreich erstellt`,
              position: { at: 'bottom center', my: 'bottom center' }
            }, 'success');
            refresh();
          } else {
            notify({
              message: `Fehler beim Hochladen der Datei: ${data.userMessage || 'Unbekannter Fehler'}`,
              position: { at: 'bottom center', my: 'bottom center' }
            }, 'error');
          }
          setisdsvLoading(false);
          setFormDataDefaults({ ...formDataDefaults });
          setPopupVisible(false);
        })
        .catch(error => {
          setisdsvLoading(false);
          notify({
            message: `Fehler beim Hochladen der Datei: ${error.userMessage || 'Unbekannter Fehler'}`,
            position: { at: 'bottom center', my: 'bottom center' }
          }, 'error');
        });

    });
  }, []);
  return (
    <div className='view competition-list'>
      <div className='view-wrapper view-wrapper-competition-list list-page'>
        <DataGrid
          className='grid theme-dependent'
          noDataText=''
          focusedRowEnabled
          width={'100%'}
          height='100%'
          dataSource={gridDataSource}
          onRowClick={onRowClick}
          onExporting={onExporting}
          allowColumnReordering
          showBorders
          ref={gridRef}
          remoteOperations={true}
        >
          <LoadPanel showPane={false} />
          <SearchPanel visible placeholder='Wettkampf suchen' />
          <Export enabled allowExportSelectedData formats={exportFormats} />
          <Selection
            selectAllMode='allPages'
            showCheckBoxesMode='always'
            mode='multiple'
          />
          <HeaderFilter visible />
          <Sorting mode='multiple' />
          <Scrolling mode='virtual' />
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Wettkämpfe</div>
            </Item>
            <Item location='before' locateInMenu='auto'>
              <DropDownButton
                items={filterStatusList}
                stylingMode='text'
                text={status}
                dropDownOptions={dropDownOptions}
                useSelectMode
                onSelectionChanged={filterByStatus}
              />
            </Item>
            <Item location='after' locateInMenu='auto'>
              <Button
                icon='plus'
                text='Neuer Wettkampf'
                type='default'
                stylingMode='contained'
                onClick={onAddCompetitionClick}
              />
            </Item>
            <Item
              location='after'
              locateInMenu='auto'
              showText='inMenu'
              widget='dxButton'
            >
              <Button
                icon='refresh'
                text='Refresh'
                stylingMode='text'
                onClick={refresh}
              />
            </Item>
            <Item location='after' locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item name='exportButton' />
            <Item location='after' locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>

          <Column dataField="startdate" caption="Beginn" dataType="date" format="dd.MM.yy" sortIndex={0} sortOrder='desc' width={80} hidingPriority={7} />
          <Column dataField="title" caption="Titel" dataType="string" minWidth={200} />
          <Column dataField="city" caption="Stadt" dataType="string" width={100} hidingPriority={6} />
          <Column dataField="course" caption="Bahn" dataType="string" width={50} hidingPriority={2} lookup={{dataSource: COURSES, valueExpr: 'id', displayExpr:'text'}}/>
          <Column dataField="headUserId" caption="Verantwortlicher" dataType="string" lookup={{ dataSource: dataSourceUser, valueExpr: 'userId', displayExpr: 'displayName' }} width={100} hidingPriority={1} />
          <Column dataField="deadlineIntern" caption="Interner Meldeschluss" dataType="date" format="dd.MM.yy HH:mm" width={120} hidingPriority={0} />
          <Column dataField="deadline" caption="Meldeschluss" dataType="date" format="dd.MM.yy HH:mm" width={120} hidingPriority={4} />
          <Column
            dataField='status'
            caption='Status'
            dataType='string'
            width={170}
            hidingPriority={5}
            cellRender={CompetitionStatus}
            editCellRender={editCellStatusRender}

          />
          <Column
          hidingPriority={3}
            caption='Statistik'
            dataType='string'
            width={120}
            cellRender={statisticsCellRender}
          />


        </DataGrid>
        {/* <CompetitionPanel competitionId={competitionId} isOpened={isPanelOpened} changePanelOpened={changePanelOpened} changePanelPinned={changePanelPinned} /> */}
        <FormPopup title='Neuer Wettkampf' visible={popupVisible} setVisible={changePopupVisibility} onSave={onSaveClick}>
          <CompetitionNewFormWithLoadPanel hasData={true} loading={isdsvLoading} initData={formDataDefaults} onDataChanged={onDataChanged} onFileChanged={onFileChanged} fileType="AUTO"/>
        </FormPopup>
      </div>
    </div>
  );
};

